import ProjectCard from "../ProjectCard/ProjectCard";
import { useAARData } from "../../context/AARDataContext";

import "./ProjectGrid.css";

function ProjectGrid({
  searchTerm = "",
  year = "",
  type = "",
  area = "",
  status = "",
}) {
  // Get AAR records from our shared context
  const { projects } = useAARData();

  const filteredProjects = projects.filter((project) => {
    const search = searchTerm.toLowerCase();

    // SEARCH
    const matchesSearch =
      (project.title || "").toLowerCase().includes(search) ||
      (project.subtitle || "").toLowerCase().includes(search) ||
      (project.location || "").toLowerCase().includes(search);

    // YEAR
    const matchesYear =
      year === "" ||
      String(project.year) === String(year);

    // TYPE
    const matchesType =
      type === "" ||
      project.type === type;

    // AREA
    const matchesArea =
      area === "" ||
      project.area === area;

    // STATUS
    const matchesStatus =
      status === "" ||
      project.status === status;

    return (
      matchesSearch &&
      matchesYear &&
      matchesType &&
      matchesArea &&
      matchesStatus
    );
  });

  return (
    <section className="projects-section">
      <div className="projects-container">

        {/* SECTION HEADER */}
        <div className="section-heading">

          <div>
            <span className="heading-line"></span>

            <h2>
              AAR RECORDS
            </h2>
          </div>

          <p>
            Showing {filteredProjects.length} of {projects.length} projects
          </p>

        </div>


        {/* PROJECT GRID */}

        {filteredProjects.length > 0 ? (

          <div className="project-grid">

            {filteredProjects.map((project) => (

              <ProjectCard
                key={project.id}
                project={project}
              />

            ))}

          </div>

        ) : (

          <div className="no-results">

            <div className="no-results-icon">
              🔍
            </div>

            <h3>
              No AAR projects found
            </h3>

            <p>
              Try changing your search or filters.
            </p>

          </div>

        )}

      </div>
    </section>
  );
}

export default ProjectGrid;